import React from "react";

const DualFormRadio = ({ setCompanyType, companyType, register }) => {
  const companyTypeHandleA = () => {
    setCompanyType(true);
  };
  const companyTypeHandleB = () => {
    setCompanyType(false);
  };
  return (
    <div>
      <div className="border-primary-blue flex border-2 md:w-[57%]">
        <p className="text-primary-red px-5 py-2  border-l font-Laila font-semibold sm:!w-[33%]">
          ब्यवसायको प्रकार
        </p>
        <div className=" border-l-2 flex  border-primary-blue">
          <div
            onClick={companyTypeHandleA}
            className="cursor-pointer  border-primary-blue px-1 ml-2 flex items-center my-2 rounded-2xl gap-2  bg-red-500"
          >
            <label htmlFor="test1" className="text-white">
              एकल
            </label>
            <input type="radio" name="a" id="test1" defaultChecked />
            {/* <div className={`${companyType === true ? "bg-yellow-400" : "bg-white"} rounded-full w-3 h-3 `}> </div> */}
          </div>
          <div
            onClick={companyTypeHandleB}
            className="cursor-pointer border-primary-blue px-1 ml-2 flex items-center my-2 rounded-2xl gap-2  bg-red-500 "
          >
            <label htmlFor="test" className="text-white">
              साझेदारी
            </label>
            <input type="radio" name="a" id="test" />

            {/* <div className={`${companyType === false ? "bg-yellow-400" : "bg-white"} rounded-full w-3 h-3 `}> </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DualFormRadio;
